import cn from 'classnames';

import { EColorMap } from '../constants/colorMap';
import { IConDefaultType } from '../types';

interface IWritingIconProps extends IConDefaultType {}

function WritingIcon({ color, className, size = 24, rotate, flip }: IWritingIconProps) {
  const fill = color || EColorMap.gray_0;
  return (
    <i
      className={cn('dds-icon', className, { flip })}
      style={{
        width: size,
        minWidth: size,
        height: size,
        transform: `rotate(${rotate}deg)`,
      }}
    >
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M17 4C18.6569 4 20 5.34315 20 7V12.3414C20.7452 12.6048 21.4229 13.0113 22 13.5278V7C22 4.23858 19.7614 2 17 2H7C4.23858 2 2 4.23858 2 7V17C2 19.7614 4.23858 22 7 22H13.5278C13.0113 21.4229 12.6048 20.7452 12.3414 20H7C5.34315 20 4 18.6569 4 17V7C4 5.34315 5.34315 4 7 4H17Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 12C7 11.4477 7.44772 11 8 11H16C16.5523 11 17 11.4477 17 12C17 12.5523 16.5523 13 16 13H8C7.44772 13 7 12.5523 7 12Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 8C7 7.44772 7.44772 7 8 7H14C14.5523 7 15 7.44772 15 8C15 8.55228 14.5523 9 14 9H8C7.44772 9 7 8.55228 7 8Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7 16C7 15.4477 7.44772 15 8 15H12C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17H8C7.44772 17 7 16.5523 7 16Z"
          fill={fill}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22 18C22 20.2091 20.2091 22 18 22C15.7909 22 14 20.2091 14 18C14 15.7909 15.7909 14 18 14C20.2091 14 22 15.7909 22 18ZM18 15.2C18.4418 15.2 18.8 15.5582 18.8 16V17.2H20C20.4418 17.2 20.8 17.5582 20.8 18C20.8 18.4418 20.4418 18.8 20 18.8H18.8V20C18.8 20.4418 18.4418 20.8 18 20.8C17.5582 20.8 17.2 20.4418 17.2 20V18.8H16C15.5582 18.8 15.2 18.4418 15.2 18C15.2 17.5582 15.5582 17.2 16 17.2H17.2V16C17.2 15.5582 17.5582 15.2 18 15.2Z"
          fill={fill}
        />
      </svg>
    </i>
  );
}

export default WritingIcon;
